$(document).ready(function() {
    if($("#aa-modal").length){
      var ulElement = $("#aa-modal");  
    }else{
      var ulElement = $("#aa");    
    }
    
    var secondLiElement = ulElement.find("span:eq(0)");
    var secondLiContent = secondLiElement.text();
    var yj_price = Number(secondLiContent.substring(1));
    var cj_price = (yj_price/4).toFixed(2);
    //$(".price_fq").html("$"+cj_price);
    $(".price_fq").text("$"+cj_price);
  });

$('.hc-quick-view').click(function(){
    var Quick_view = "QuickShopModal-"+$(this).attr('id');
    var pp = "#"+Quick_view;
    $(pp).addClass("Qv");
    sessionStorage.setItem('Qid',Quick_view);
    //console.log(Quick_view);
    var handle = '#ProHandle'+$(this).attr('id');
    var handle_text = $(handle).text();
    var productId = $(this).attr('id');
    myFunc(handle_text, productId);
    //var pro_desc = document.getElementById("pro_desc");
    //pro_desc.style.display = "none";
    
    showPopup();
});
function myFunc(handle, productId){
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle;
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
    //console.log(url);
    sessionStorage.setItem('url',url);
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      // Convert the HTML string into a document object
      
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="'+handle+'"]');
                       
      if (!holder) {
        return;
      }  
      holder.innerHTML = '';
      holder.append(div);
     
      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);
      var pop = "#pro_desc";
      $(pop).addClass("hide_new");
      $("#popup").removeClass("yincang");
      $("#tab01").addClass("hide_new");
      $("#tab02").addClass("hide_new");
      $("#moreDetail").removeClass("hide_new");
      var tz = document.getElementById("moreDetail");
      tz.addEventListener("click", function(){
      var newurl = sessionStorage.getItem("url");
      console.log(newurl);
      window.location.href = 'https://sterlyhair.com'+newurl;
    });
    });
}

$('.modal__close').click(function(){
    var pp = "#"+sessionStorage.getItem("Qid");
    $(pp).removeClass("Qv");
    var popup = document.getElementById("popup");
    sessionStorage.removeItem('Qid');
    sessionStorage.removeItem('url');
    var pop = "#pro_desc";
    $(pop).removeClass("hide_new");
    $("#tab01").removeClass("hide_new");
    $("#tab02").removeClass("hide_new");
    $("#popup").addClass("yincang");
});

function atc() {
  var pp = "#"+sessionStorage.getItem("Qid");
  $(pp).removeClass("Qv");
  var popup = document.getElementById("popup");
  popup.style.display = "none";
  sessionStorage.removeItem('Qid');
  sessionStorage.removeItem('url');
  var pop = "#pro_desc";
  $(pop).removeClass("hide_new");
}

function showPopup() {
    $("#popup").removeClass("yincang");
}